<div class="flex flex-1 flex-col w-full">
  <div class="flex flex-row py-3 pl-4 pr-6 border-b border-gray-1">
    <div class="h-8 flex flex-1 flex-wrap content-center font-semibold">
      {{ translations.title.text }}
    </div>
    <button
      modus-icon-button
      id="recycle-bin-options-panel-close"
      class="text-gray-8"
      [modus-tooltip]="translations.close.tooltip.text"
      [disabled]="disabled()"
      (click)="closeClicked.emit()"
    >
      <md-icon>close</md-icon>
    </button>
  </div>

  <div class="flex-1 overflow-y-scroll" cdkScrollable>
    <div class="flex flex-col max-w-full">
      @let model = selectedScan();

      <div class="flex flex-row px-4 py-1">
        <!-- model name -->
        <div
          class="w-full overflow-hidden text-ellipsis whitespace-nowrap leading-8 text-primary font-semibold"
          [modus-tooltip]="model.name"
        >
          {{ model.name }}
        </div>

        <!-- preview button -->
        <button
          modus-icon-button
          id="options-panel_toggle_preview"
          class="text-gray-8"
          [disabled]="previewButtonDisabled()"
          [modus-tooltip]="previewButtonTooltip()"
          (click)="togglePreview()"
        >
          @if (showPreview()) {
            <md-icon>visibility_on</md-icon>
          } @else {
            <md-icon>visibility_off</md-icon>
          }
        </button>
      </div>

      <!-- preview -->
      @if (showPreview()) {
        <div class="w-full px-4 pb-4 pt-[0.1rem]">
          <div class="flex border border-gray-200 w-full overflow-hidden items-center h-[200px]">
            <sd-viewer-glb [sourceUri]="model.previewUrl"></sd-viewer-glb>
          </div>
        </div>
      }

      <!-- details -->
      <div class="p-4 pt-1">
        <sd-properties [scandataModel]="model" [readonly]="true" [showTags]="true"></sd-properties>
      </div>
    </div>
  </div>
</div>
